import React from 'react';
import { Link } from 'react-router-dom';
interface LogoProps {
  /** Height classes for the logo tile, e.g. "h-[120px]". Width follows the artwork's proportions. */
  sizeClass?: string;
  asLink?: boolean;
  className?: string;
}

/**
 * Original Liftoff Investments logo artwork (white tile version supplied by the company).
 * To upgrade quality, replace LOGO_SRC with a high-resolution PNG or SVG export of the logo file.
 */
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/xuecqsnds4iUF7w4GVVNxR/image.png';
export function Logo({
  sizeClass = 'h-[96px]',
  asLink = true,
  className = ''
}: LogoProps) {
  const content = <img src={LOGO_SRC} alt="Liftoff Investments (Pty) Ltd" loading="eager" decoding="async" className={`block w-auto rounded-lg object-contain ${sizeClass} ${className}`} data-id="element-555" data-mp="8xqwk226i7iw" />;
  if (!asLink) return content;
  return <Link to="/" aria-label="Liftoff Investments home" className="inline-flex shrink-0" data-id="element-556" data-mp="1z9520hlet1jo">
      {content}
    </Link>;
}